import abilitiesRoutes from "@/router/abilities-routes"
import adversariesRoutes from "@/router/adversaries-routes"
import operationsRoutes from "@/router/operations-routes"
import supportRoutes from "@/router/support-routes"
import agentsRoutes from "@/router/agents-routes"
import userRoutes from "@/router/user-routes"
import contentsRoutes from "@/router/contents-routes"
import factRoutes from "@/router/facts-routes"
import rulesRoutes from "@/router/rules-routes"
import reportsRoutes from "@/router/reports-routes"
import assessmentsRoutes from "@/router/assessments-routes"
import { useAuth } from "@/stores/auth"
import type { RouteRecordRaw } from "vue-router"

export async function hasPermission(
  name: string,
  method: "get" | "post" | "put" | "patch" | "delete"
) {
  const auth = useAuth()
  if (auth.loggedUser.user_group?.[0].group.group_permissions) {
    auth.loggedUser.user_group?.[0].group?.group_permissions.find(
      p => p.permission.route_name === name && p.permission.method === method
    )
  }
}

function getContentBreadcrumb() {
  const currentLink = window.location.href
  let breadcrumb = "contents.breadcrumbs.versions"

  if (currentLink.includes("/news/")) {
    breadcrumb = "contents.breadcrumbs.news"
  } else if (currentLink.includes("/faq/")) {
    breadcrumb = "contents.breadcrumbs.faq"
  }

  return breadcrumb
}

const protectedRoutes: RouteRecordRaw[] = [
  {
    path: "/user-options",
    name: "userOptions",
    component: () => import("@/views/UserView.vue"),
    meta: { breadcrumb: "userMenu.options" },
    children: userRoutes
  },
  {
    path: "/abilities",
    name: "AbilitiesView",
    component: () => import("@/views/AbilitiesView.vue"),
    meta: { breadcrumb: "userMenu.abilities" },
    children: abilitiesRoutes,
    beforeEnter: () => {
      return hasPermission("/api/v1/abilities", "get")
    }
  },
  {
    path: "/adversaries",
    name: "adversaries",
    component: () => import("@/views/AdversariesView.vue"),
    meta: { breadcrumb: "adversaries.breadcrumbTitle" },
    children: adversariesRoutes,
    beforeEnter: () => {
      return hasPermission("/api/v1/adversaries", "get")
    }
  },
  {
    path: "/operations",
    name: "operations",
    component: () => import("@/views/OperationsView.vue"),
    meta: { breadcrumb: "operations.navbarTitle" },
    children: operationsRoutes,
    beforeEnter: () => {
      return hasPermission("/api/v1/operations", "get")
    }
  },
  {
    path: "/agents",
    name: "agents",
    component: () => import("@/views/AgentsView.vue"),
    meta: { breadcrumb: "agents.title" },
    children: agentsRoutes,
    beforeEnter: () => {
      return hasPermission("/api/v1/agent", "get")
    }
  },
  {
    path: "/support",
    name: "support",
    component: () => import("@/views/SupportView.vue"),
    meta: { breadcrumb: "userMenu.options" },
    children: supportRoutes
  },
  {
    path: "/contents",
    name: "contents",
    component: () => import("@/views/ContentsView.vue"),
    meta: { breadcrumb: getContentBreadcrumb() },
    children: contentsRoutes
  },
  {
    path: "/facts",
    name: "facts",
    component: () => import("@/views/FactsView.vue"),
    meta: { breadcrumb: "facts.list.title" },
    children: factRoutes
  },
  {
    path: "/rules",
    name: "rules",
    component: () => import("@/views/RulesView.vue"),
    meta: { breadcrumb: "rules.list.title" },
    children: rulesRoutes
  },
  {
    path: "/reports",
    name: "report",
    component: () => import("@/views/ReportsView.vue"),
    meta: { breadcrumb: "reports.title" },
    children: reportsRoutes
  },
  {
    path: "/assessments",
    name: "assessment",
    component: () => import("@/views/AssessmentsView.vue"),
    meta: { breadcrumb: "assessments.title" },
    children: assessmentsRoutes,
    beforeEnter: () => {
      return hasPermission("/api/v1/assessments", "get")
    }
  },
  {
    path: "",
    name: "dashboard",
    component: () => import("@/templates/dashboard/Index.vue"),
    meta: { breadcrumb: "navbar.home" }
  }
]

export default protectedRoutes
